/**
 * Utility methods
 * 
 * @author Leander Eyer <leander.eyer@elead.ch>
 */

export { shuffle, processSearchTerm, tagToID, filterNonNumeric, hasNumeric };

/** Shuffle an array by Fisher-Yates */
function shuffle(array) {
    let curIdx = array.length;
    let rndIdx = -1;
    let tmpValue = null;

    while (0 !== curIdx) {
        rndIdx = Math.floor(Math.random() * curIdx);
        curIdx--;
        tmpValue = array[curIdx];
        array[curIdx] = array[rndIdx];
        array[rndIdx] = tmpValue;
    }

    return array;
}

/** Split the Search Term by spaces, while keeping quoted text together */
function processSearchTerm(term) {
    let list = [];
    let token = "";
    let inQuote = false;

    term = term.toLowerCase();
    for (let i = 0; i < term.length; i++) {
        let char = term.charAt(i);

        if (char == '"') {
            inQuote = !inQuote;
        } else if (char == ' ' && inQuote == false) {
            if (token.length > 0) {
                list.push(token);
                token = "";
            }
        } else {
            token += char;
        }
    }

    if (token.length > 0) {
        list.push(token);
        token = "";
    }
    return list;
}

/** Convert a Tag to an ID Form */
function tagToID(tag) {
	let token = "";

	var allowed = "abcdefghijklmnopqrstuvwxyz";
	tag = tag.toLowerCase();
    for (let i = 0; i < tag.length; i++) {
		let char = tag.charAt(i);
		if (allowed.indexOf(char) != -1) {
			token += char;
		} else {
			token += '_';
			token += char.charCodeAt(0);
		}
    }

	return token;
}

/** Filter out any num numerical chars */
function filterNonNumeric(input) {
	let token = "";
	var numeric = "0123456789.,";
    for (let i = 0; i < input.length; i++) {
		let char = input.charAt(i);
		if (numeric.indexOf(char) != -1) {
			token += char;
		}    
	}

	return token;
}

/** Filter out any num numerical chars */
function hasNumeric(input) {
	var numeric = "0123456789.,";
    for (let i = 0; i < input.length; i++) {
		let char = input.charAt(i);
		if (numeric.indexOf(char) != -1) {
			return true;
		}    
	}
	return false;
}
